import * as React from "react";
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const { onSubmitSeaPatterns /* onCloseSeaPatterns */ } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-datepicker
   * @name react-custom-scrollbars
   * @name lodash
   * @name i18next
   * @name react-datepicker
   * @infos "https://reactjs.org"
   */
  return (
    <div className="PatternFalseAlarm  animated slideInUp">
      <div className="patternHeader">
        {" "}
        <span> {i18next.t("fausse alarme")}</span>
      </div>
      <div className="patternContent">
        <div className="patternContentInsider">
          <span className="patternContentInsiderTitle seaPatternTitle">
            {" "}
            {i18next.t("voulez - vous envoyer vers le SAE")}{" "}
          </span>
          <div className="patternContentInsiderButton">
            <div className="modalBtn" style={{ textAlign: "center" }}>
              <span className="borderGradian" onClick={onSubmitSeaPatterns}>
                {" "}
                <span
                  className="btnSecondary "
                  style={{ backgroundColor: "white", overflow: "visible" }}
                >
                  <span className="textGradianlarge">{i18next.t("non")}</span>
                </span>
              </span>
              <button
                className="btnPrimary ripple"
                style={{
                  padding: "7px 20px",
                  display: "inline-block",
                  marginLeft: "6px",
                }}
                onClick={onSubmitSeaPatterns}
              >
                {i18next.t("oui")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onSubmitSeaPatterns?: any;
  onCloseSeaPatterns?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/sae/component.tsx